import styled from '@emotion/styled';
import { Text } from 'ds/components/typography';

export const InfoWrapper = styled.div`
  ${({ theme }) => `
    display: flex;
    align-items: center;
    padding-bottom: ${theme.spacing(2)};
    color: ${theme.colors.neutrals.grey1};
    border-bottom: 1px solid ${theme.colors.neutrals.grey8};
  `}
`;

export const LogoImg = styled.div<{ imageUrl: string; }>`
  ${({ imageUrl, theme }) => `
    height: 48px;
    width: 48px;
    background-repeat: no-repeat;
    background-position: center;
    background-color: ${theme.colors.neutrals.white};
    ${imageUrl ? `
      background-image: url("${imageUrl}");
    ` : ``}
    transform-origin: top left;
    margin-left: ${theme.spacing(2)};
    background-size: contain;
  `}
`;

export const ContactInfoWrapper = styled.div`
  ${({ theme }) => theme.media.showAt({ from: 2 })`
    display: flex;
    justify-content: space-between;
    margin-top: ${theme.spacing(1)};
    margin-bottom: ${theme.spacing(2)};
  `}
`;
export const ContactInfoInner = styled.div`
  ${({ theme }) => theme.media.showAt({ from: 2 })`
    width: calc(50% - 6px);
  `}
  ${({ theme }) => theme.media.showAt({ at: 1 })`
    margin-bottom: ${theme.spacing(2)};
  `}
`;

export const SuccessWrapper = styled.div`
  text-align: center;
  white-space: pre-line;

  ${({ theme }) => theme.media.showAt({ from: 2 })`
    width: 385px;
    padding: ${theme.spacing(1.25)} 0 ${theme.spacing(1)};
    margin-top: ${theme.spacing(4)};
    border-radius: ${theme.borderRadius.small};
    background-color: ${theme.colors.neutrals.grey11};
  `}

  ${({ theme }) => theme.media.showAt({ at: 1 })`
    margin-top: ${theme.spacing(5)};
  `}
`;

export const PhoneHint = styled(Text)`
  ${({ theme }) => `
    color: ${theme.colors.neutrals.grey1};
  `}
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  ${({ theme }) => theme.media.showAt({ to: 2 })`
    padding: ${theme.spacing(2)} ${theme.spacing(1)};
  `}

  ${({ theme }) => theme.media.showAt({ from: 3 })`
    margin: ${theme.spacing(4)} -${theme.spacing(4)} -${theme.spacing(4)};
    padding: ${theme.spacing(2.5)} ${theme.spacing(4)};
    border-top: 1px solid ${theme.colors.neutrals.grey8};
  `}
`;

export const MobileContactWrapper = styled.div`
  ${({ theme }) => `
    display: flex;
    left: 0;
    width: 100%;
    position: fixed;
    bottom: 0;
    background-color: ${theme.colors.neutrals.white};
    z-index: 1;
    padding: ${theme.spacing(2.5)};
    border-top: 1px solid ${theme.colors.neutrals.grey8};
  `}
`;

export const MobileContactButtonWrapper = styled.div`
  ${({ theme }) => `
    flex-basis: 50%;
    margin: 0 ${theme.spacing(0.5)};
  `}
`;

export const MobileModalSeparator = styled.div`
  ${({ theme }) => `
    border-top: 1px solid ${theme.colors.neutrals.grey8};
    margin: ${theme.spacing(5)} auto;
    width: 94px;
  `}
`;

export const ReasonsWrapper = styled.div`
  white-space: pre-line;
`;
